app.service('order', function (main, front, loginView, basketView, notIssuedOrderView, obligatoryChangePassword){
	$(document).on('pageChange', function() {
		run();
	});
	function setElements() {

	}
	function run(){
		switch(front.page()) {
			case 'basket':
				basketView.init(); // tylko w WC, dla pozostałych frontów mamy zaślepki
				break;
			case 'not-issued-order':
				notIssuedOrderView.init(); // tylko w WC, dla pozostałych frontów mamy zaślepki
				break;
			case 'obligatory-change-password':
				obligatoryChangePassword.init();
				break;
			case 'accountLogin':
				
			case 'login':
				loginView.init();
			default:
				break;
		}
	}
	function setEvents() {
		run();
	}
	function init(){
		setElements();
		setEvents();
	}
	main.onLoad(init);
});
